import useDetailCard from './useDetailCard';
/** INFO: 20 May 2025 - This card used to contain all the logic now contained in useDetailCard. This file is retained for backwards compatability and can be used as the normal detail card component with no extra bells and whistles.
 * The hook allows parent components to extend the detail card, such as the {@link ./UserDetailCard.tsx | UserDetailCard}
 * */
export default function DetailCard(props) {
    const { detailCardComponents } = useDetailCard(props);
    return detailCardComponents.wholeComponent;
}
